import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';
import { flow as flowFn, get, set } from 'lodash-es';
import {
  CUSTOMER_OF_QUESTION_ID,
  ENGINE_TYPE_QUESTION_ID,
} from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';
import { PUB_STATES_LOWERCASE } from 'client/constants/pub-states';
import { getUtilityEvChargingOfferRebates } from 'site-modules/shared/components/incentives/incentives-wizard/utils/get-utility-ev-charging-offer-rebates';

/**
 * Decide whether to delete or not CUSTOMER_OF_QUESTION_ID.
 *
 * @param {Programs} programs
 * @returns {Programs}
 * @description
 *  - If programType=Charger Installation and subtypeId is NOT 575
 *   Then do not ask CUSTOMER_OF_QUESTION_ID question
 */
function filterOutChargerInstallationQuestions(programs) {
  const updatedPrograms = programs;
  const chargerInstallation = updatedPrograms[PROGRAM_TYPES.CHARGER_INSTALLATION];
  const chargerInstallationIncentives = get(chargerInstallation, 'incentives', []);

  if (chargerInstallation && !getUtilityEvChargingOfferRebates(chargerInstallationIncentives).length) {
    const updatedFlow = updatedPrograms[PROGRAM_TYPES.CHARGER_INSTALLATION].flow.filter(
      question => question !== CUSTOMER_OF_QUESTION_ID
    );
    set(updatedPrograms, `[${PROGRAM_TYPES.CHARGER_INSTALLATION}].flow`, updatedFlow);
  }

  return updatedPrograms;
}

/**
 * Decide whether to delete or not ENGINE_TYPE_QUESTION_ID.
 *
 * @param {Object} context - data structure with common data
 * @param {string} context.type - publication state value (new, used, ...)
 * @param {Array.<string>} context.engineTypes - an array of engine values
 * @returns {(function(Programs): Programs)}
 * @description
 *  - should remove ENGINE_TYPE_QUESTION_ID for new vehicles and for used vehicles that do not have multiple engine values
 */
function filterOutEngineTypeQuestion(context) {
  return programs => {
    if (context.type === PUB_STATES_LOWERCASE.USED && context.engineTypes?.length > 1) {
      return programs;
    }

    return Object.fromEntries(
      Object.entries(programs).map(([program, programFlow]) => [
        program,
        { ...programFlow, flow: programFlow.flow.filter(step => step !== ENGINE_TYPE_QUESTION_ID) },
      ])
    );
  };
}

/**
 * Remove redundant question IDs from a flow for a specific program based on the initial data.
 *
 * @param {Object} context
 * @param {string} context.type - publication state value (new, used, ...)
 * @param {Array.<string>} context.engineTypes - an array of engine values
 * @returns {(programs: Programs) => Programs}
 */
export function filterOutRedundantQuestions(context) {
  return flowFn([filterOutChargerInstallationQuestions, filterOutEngineTypeQuestion(context)]);
}
